import React from 'react'
import styles from './Grid.module.scss'

type Cols = '1' | '2' | '3' | '4' | '6' | '12'
type Gap = '2' | '4' | '6' | '8'

interface GridProps {
  children: React.ReactNode
  cols?: Cols
  gap?: Gap
  className?: never
}

const colsMap: Record<Cols, string> = {
  '1': styles.cols1, '2': styles.cols2, '3': styles.cols3,
  '4': styles.cols4, '6': styles.cols6, '12': styles.cols12,
}

const gapMap: Record<Gap, string> = {
  '2': styles.gap2, '4': styles.gap4, '6': styles.gap6, '8': styles.gap8,
}

export const Grid: React.FC<GridProps> = ({ children, cols = '4', gap = '4' }) => (
  <div className={[styles.grid, colsMap[cols], gapMap[gap]].join(' ')}>
    {children}
  </div>
)
